import React from "react";
import { MdCancel } from "react-icons/md";
import { useSelector } from "react-redux";
import "./News.css";
const News = (props) => {
  const mode = useSelector((state) => state.reducer1.mode);

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        zIndex: "100",
        width: "100vw",
        // height: "100vh",
      }}
    >
      <nav style={{ display: "flex" }}>
        <div style={{ display: "grid", placeItems: "center" }}>
          {mode == "day" ? (
            <img src="/img/logo-b.png" alt="" />
          ) : (
            <img src="/img/logo-w.png" alt="" />
          )}
          <p
            className="klee-one-regular"
            style={{
              color: mode == "day" ? "black" : "white",
              fontSize: ".8rem",
            }}
          >
            - Make the Region -
          </p>
        </div>

        <div
          className="cancelBtn"
          style={{ color: "white" }}
          onClick={() => {
            // setTimeout(() => {
            props.cancelNews();
            // }, 400);
            document.getElementById("main").className = "animateAboutClose";
          }}
        >
          <MdCancel />
        </div>
      </nav>

      <main
        id="main"
        className="animateAbout contactCard"
      >
        <h2
          className="luckiest-guy-regular"
        >
          CONTACT US
        </h2>
        <h4
          className="interFont"
          style={{ color: "#828282", marginBottom: "1rem" }}
        >
          Subheading for description or instructions
        </h4>

        {/* <img style={{ width: "450px" }} src="/img/Form.png" alt="" /> */}

        <section className="interFont">
          <div className="contactName">
            <div>
              <label style={{ color: "black" }} htmlFor="fname">
                First Name
              </label>
              <br />
              <input
                style={{
                  borderRadius: "8px",
                  border: "1px solid gray",
                  color: "black",
                }}
                type="text"
                id="fname"
                name="firstname"
                placeholder="John"
              />
            </div>

            <div style={{marginLeft:"auto"}}>
              <label className="lastName" style={{ color: "black" }} htmlFor="fname">
                Last Name
              </label>
              <br />
              <input
                style={{
                  borderRadius: "8px",
                  border: "1px solid gray",
                  color: "black",
                }}
                type="text"
                id="fname"
                name="firstname"
                placeholder="Doe"
              />
            </div>
          </div>

          <div className="contactEmail">
            <label style={{ color: "black" }} htmlFor="fname">
              Email address
            </label>
            <br />
            <input
              style={{
                borderRadius: "8px",
                border: "1px solid gray",
                color: "black",
              }}
              type="text"
              id="fname"
              name="firstname"
              placeholder="email@johndoe.net"
            />
          </div>

          <div className="contactMsg">
            <label style={{ color: "black" }} htmlFor="fname">
              Your message
            </label>
            <br />
            <textarea
              style={{
                borderRadius: "8px",
                border: "1px solid gray",
                resize: "none",
                color: "black",
              }}
              // type="text"
              // id="fname"
              // name="firstname"
              placeholder="Enter your question or message"

              // rows={9}
              // cols={50}
            />
          </div>

          <input
          className="contactBtn"
            style={{
              backgroundColor: "#192F83",
              color: "white",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
            }}
            type="submit"
            value="Submit"
          />
        </section>
      </main>
    </div>
  );
};

export default News;
